import { type AvatarFallbackProps, Fallback } from "./Fallback";
import { type AvatarImageProps, Image } from "./Image";
import { type AvatarIndicatorProps, Indicator } from "./Indicator";
import { type AvatarRootProps, Root } from "./Root";

export const Avatar = { Root, Image, Fallback, Indicator };

export { type AvatarFallbackProps, type AvatarImageProps, type AvatarIndicatorProps, type AvatarRootProps };
